import { FC, memo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CREATE_DOCTOR_APPOINTMENT } from 'gql/appointments/mutation';
import { useMutation } from '@apollo/client';
import { VideoCameraAddOutlined } from '@ant-design/icons';
import { CreateAppointmentByDoctor } from 'gql/appointments/__generated__/CreateAppointmentByDoctor';

import { showErrorMessage } from 'utils/showErrorMessage';
import { CreateItem } from 'components/shared';
import CreateVideoCallModal, {
  CreateVideoCallModalRef
} from '../CreateVideoCallModal';

interface IProps {
  onCreate(): void;
}

const CreateVideoCall: FC<IProps> = ({ onCreate }) => {
  const { t } = useTranslation();
  const modalRef = useRef<CreateVideoCallModalRef>(null);
  const [isModalVisible, setModalVisible] = useState(false);

  const [createAppointment, { loading: isCreating }] =
    useMutation<CreateAppointmentByDoctor>(CREATE_DOCTOR_APPOINTMENT, {
      onCompleted(data) {
        if (data.createAppointmentByDoctor?.data?.id) {
          modalRef.current?.onAppointmentCreated(
            data.createAppointmentByDoctor.data.id
          );
        }
      },
      onError: err => showErrorMessage(err)
    });

  const onClose = () => {
    setModalVisible(false);
  };

  const onCreateAppointment = (notes: string) => {
    createAppointment({ variables: { input: { notes } } });
  };

  return (
    <>
      <CreateItem title={t('video_call.create_new')}>
        <Button
          size="large"
          type="primary"
          loading={isCreating}
          icon={<VideoCameraAddOutlined />}
          onClick={() => setModalVisible(true)}
        >
          {t('video_call.create_new')}
        </Button>
      </CreateItem>
      {isModalVisible && (
        <CreateVideoCallModal
          ref={modalRef}
          onClose={onClose}
          onCreateAppointment={onCreateAppointment}
          onCreate={onCreate}
        />
      )}
    </>
  );
};

export default memo(CreateVideoCall);
